import React from 'react';
import { Mail, Linkedin, ArrowRight, CheckCircle } from 'lucide-react';

/** SectionContact – Book a discovery call with next steps. */
export default function SectionContact({ content }) {
  const contact = content || {};
  const heading = contact.heading ?? 'Book a Discovery Call';
  const subtext = contact.subtext ?? '';
  const email = contact.email ?? '';
  const linkedinUrl = contact.linkedinUrl ?? '#';
  const nextSteps = Array.isArray(contact.nextSteps) ? contact.nextSteps : [];
  if (!email && !heading) return null;

  return (
    <section id="contact" className="py-16 sm:py-20 border-t" style={{ background: 'var(--jb-forest-bg-2)', borderColor: 'var(--jb-border)' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="text-center mb-10">
          {heading && <h2 className="font-display font-extrabold text-2xl sm:text-3xl text-text-hero mb-3">{heading}</h2>}
          {subtext && <p className="font-body text-text-sub max-w-xl mx-auto">{subtext}</p>}
        </div>

        <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* Contact links */}
          <div className="p-6 rounded-xl border" style={{ background: 'var(--jb-forest-card)', borderColor: 'var(--jb-border)' }}>
            <p className="font-mono text-[0.7rem] uppercase tracking-widest text-text-muted mb-4">Get in touch</p>
            <div className="space-y-4">
              {email && (
                <a
                  href={`mailto:${email}?subject=Discovery%20Call%20Request`}
                  className="flex items-center gap-3 font-body text-text-body hover:text-cyan transition group"
                >
                  <Mail className="w-5 h-5 flex-shrink-0 text-cyan" />
                  <span className="break-all">{email}</span>
                </a>
              )}
              <a
                href={linkedinUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 font-body text-text-body hover:text-cyan transition"
              >
                <Linkedin className="w-5 h-5 flex-shrink-0 text-cyan" />
                <span>LinkedIn</span>
              </a>
            </div>

            {email && (
              <a
                href={`mailto:${email}?subject=Discovery%20Call%20Request`}
                className="jb-cta mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-gradient-to-r from-cyan to-accent-green text-forest-bg font-body font-bold text-sm hover:opacity-90 transition"
              >
                Book a call <ArrowRight className="w-4 h-4" />
              </a>
            )}
          </div>

          {/* What happens next */}
          {nextSteps.length > 0 && (
            <div className="p-6 rounded-xl border" style={{ background: 'var(--jb-forest-card)', borderColor: 'var(--jb-border)' }}>
              <p className="font-mono text-[0.7rem] uppercase tracking-widest text-text-muted mb-4">What happens next</p>
              <ol className="space-y-4">
                {nextSteps.map((step, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5 text-cyan" />
                    <span className="font-body text-sm text-text-body">{step}</span>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
